const axios = require("axios");
let latestPromise;
let queue = [];
//test
const serachJkNonConcurrent = async (queryString, buildersIds) => {
    const { hostname } = location;
    if (!latestPromise) {
        latestPromise = axios.post(
            "https://content-distribution-jk-search.content.cian.ru/serach-jk?" +
            queryString,
            {builders: buildersIds, hostname},
            {timeout:10000}
        );
    } else {
        latestPromise = new Promise(resolve => {
            queue.push({queryString, buildersIds, resolve})
        });
    }
    latestPromise.then((resp) => {
        const next = queue.shift();
        if (next) {
            axios.post(
                "https://content-distribution-jk-search.content.cian.ru/serach-jk?" +
                next.queryString,
                {builders: next.buildersIds, hostname},
                {timeout:10000}
            ).then(next.resolve);
        } else {
            latestPromise = false;
        }
        return resp;
    })
    return latestPromise;
}

const urls = [
    "/finance/content-distribution-mini-fotogallery/widget.js",
    "/finance/content-distribution-mobile-fotogallery/widget.js",
    "/finance/content-distribution/customization.js",
    "/finance/listing-photo-gallery/widget.js",
    "/finance/content-distribution-call-tracking-button/widget.js",
    "/finance/call-tracking-button-light/widget.js",
    "/finance/mortgage-button/widget.js",
    "/finance/newbuilding-filters/widget.js",
    "/finance/newbuilding-filters-mobile/widget.js",
    "/finance/finance/favourites-component/widget.js",
    "/finance/breadcrumbs/widget.js",
    "/finance/cian-cd-partners-badge/widget.js",
    "/finance/cian-shahe-component/widget.js",
    "/finance/cian-tooltip/widget.js",
    "/finance/content-distribution-search-link/widget.js"
];

urls.forEach((url) => {
    if (!document.querySelector(`script[src="//cdn.cian.site${url}"]`)) {
        const scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.charset = "utf-8";
        scriptTag.src = `//cdn.cian.site${url}`;
        document.head.appendChild(scriptTag);
    }
});

if (!customElements.get("cian-content-jk-search"))
    customElements.define(
        "cian-content-jk-search",
        class extends HTMLElement {
            static get observedAttributes() {
                return ["page", "cian-query", "initialcity"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'initialcity') {
                    const { hash } = location;
                    // перерисовать страницу если значение изменилось и в qs только initialCity
                    if (oldValue !== newValue && hash.split('&').length === 1) {
                        console.log({hash: decodeURI(hash), oldValue, newValue});
                        this.connectedCallback();
                    }

                }

                if (oldValue !== newValue) {
                    localStorage.setItem(
                        "jk-search-query-string",
                        this.getAttribute("cian-query")
                    );
                    localStorage.setItem(
                        "search-query-string",
                        this.getCianQueryStringForSearch()
                    );
                    if (this.querySelector("jk-filters")) {
                        this.querySelector("jk-filters").setAttribute(
                            "cian-query",
                            this.getAttribute( "cian-query")
                        );
                    }
                    if (this.querySelector("jk-mobile-navigation")) {
                        this.querySelector("jk-mobile-navigation").setAttribute(
                            "cian-query",
                            this.getAttribute("cian-query")
                        );
                    }
                    if (name === "page") {
                        this.reloadCurrentPage(newValue);
                    } else this.reloadCurrentPage(1);
                }
            }

            init() {
                window.history.scrollRestoration = "manual";
                const serpMainContainerClass =
                    window.innerWidth > 1024
                        ? "serp-main-container-desktop"
                        : "serp-main-container-mobile";
                const isAkbars = window.location.href.includes('akbars')
                if (this.childElementCount === 0) {
                    this.innerHTML = `<!--noindex--><div class=${serpMainContainerClass}>
            ${!isAkbars ? `<div class="serp-jk-bread-crumbs-container">
                <cian-breadcrumbs></cian-breadcrumbs>
                <div id='add-advert-button' class="add-advert-button">+ Разместить объявление</div>
            </div>` : ''}
<!--            <div serp-seo-breadcrumbs style="display:none; padding: 25px 0;">Тут будут SEO хлебные крошки</div>-->
             
            ${
                        window.innerWidth > 1024
                            ? `<div class="serp-jk-filters-desktop-container"><jk-filters style="display: block" cian-query="${this.getAttribute(
                            "cian-query"
                            )}" no-shadow ></jk-filters></div>`
                            : `<div class="serp-jk-mobile-navigation"><jk-mobile-navigation cian-query="${this.getAttribute(
                            "cian-query"
                            )}"></jk-mobile-navigation></div>`
                    }
            <div class="serp-jk-title-container">
                <main-jk-title style=" font-size: 28px; line-height: 28px; font-weight: bold;">Аккредитованные новостройки</main-jk-title>
                <similar-jk-title style=" font-size: 28px; line-height: 28px; font-weight: bold; display: none">Похожие предложения</similar-jk-title>
                ${!isAkbars ? `<div class="search-jk-cian-partner-title__item" style="padding-top: 14px; font-size: 14px;line-height: 17px;color: #7C8793;">Поиск недвижимости от Циан</div>` : ''}
            </div>
            <cian-serp-jk-ad-place id="cian-serp-jk-ad-place" class="serp-jk-ad-container"></cian-serp-jk-ad-place>
            <div cian-jk-listing-content class="serp-jk-content-container"></div>
            <div button-bar class="serp-jk-show-more-button-bar">
                <div show-more class="serp-jk-show-more-button">Показать ещё</div>
<!--                <div show-more style="color: #0057B6;background: #E9F1F9;border-radius: 2px; padding: 14px; font-family: 'Proxima Nova'; min-width: 288px; text-align: center;font-size: 16px;line-height: 20px; cursor: pointer"></div>-->
            </div>
            <div seo-cross-links-block></div>
        </div>
       <!--/noindex-->`;
                }
            }

            getCianQueryString(page) {
                let queryString = this.getAttribute("cian-query");
                const {hostname, hash} = location;
                // if (hostname.includes("open") && hash.length > 1) {
                //     queryString = hash.slice(1);
                //     this.setAttribute("cian-query", queryString);
                // }
                if (!!page) {
                    if (!queryString.includes("p=")) {
                        queryString += "&p=" + page;
                    } else {
                        queryString = queryString.replace(/(?:&p=)([0-9]+)/, "&p=" + page);
                    }
                }
                if (!queryString.includes("deal_type=")) {
                    queryString += "&deal_type=sale";
                }
                if (!queryString.includes("engine_version=")) {
                    queryString += "&engine_version=2";
                }
                if (!queryString.includes("offer_type=")) {
                    queryString += "&offer_type=newobject";
                }
                if (hostname.includes("unicredit") && !queryString.includes('banks[0]')) {
                    queryString += "&banks[0]=7291";
                }
                if (hostname.includes("open") && !queryString.includes('banks[0]')) {
                    queryString += "&banks[0]=7578";
                }
                if (hostname.includes("gazprombank") && !queryString.includes('banks[0]')) {
                    queryString += "&banks[0]=7288";
                }
                // if (!queryString.includes("region") && !queryString.includes('newobject[0]') && hash.length < 1) {
                //     queryString += `&region=${this.getRegionId()}`;
                // }
                if(!!window.cian_bank_id) {
                    console.log('cian bank id', window.cian_bank_id)
                    queryString += `&banks[0]=${window.cian_bank_id}`;
                }
                return queryString;
            }

            getCianQueryStringForSearch() {
                let queryString = this.getCianQueryString(1);
                queryString = queryString.replace(/&finish_date=(\d*\.?\d+)/, "");
                queryString = queryString.includes("offer_type=newobject")
                    ? queryString.replace("offer_type=newobject", "offer_type=flat")
                    : `${queryString}&offer_type=flat`;
                return queryString;
            }

            getBuilderIds() {
                const ppString = localStorage.getItem("partner-programs");
                const partnerPrograms = !!ppString ? JSON.parse(ppString) : [];
                const builderIds = !!partnerPrograms.length
                    ? partnerPrograms.map((pp) => pp.builder_id).filter((id) => !!id)
                    : [];
                return builderIds;
            }

            getRegionId() {
                return window.__regionId || 1;
            }

            async connectedCallback() {
                const { hostname, hash } = location;
                this.saveEvent("visited", "listing-jk");
                if (
                    hostname.includes("open") &&
                    !hash.includes("region")
                ) {
                    let initialCity = this.getAttribute("initialcity");
                    try {
                        const {
                            data,
                        } = await axios.post(
                            "https://gpb-service.content.cian.ru/api/v1/location-by-city-name",
                            {name: initialCity},
                            {timeout:3000}
                        );
                        const {id, name} = data;
                        this.setAttribute("cian-query", `region=${id}`);
                        console.log({id, name});
                    } catch (e) {
                        console.log({
                            message: `Error from get-location-by-cityname% ${e}`,
                        });
                    }
                }
                this.init();
                this.classList.add("nr-wrapper");
                const qs = this.getAttribute("cian-query");
                if (!this.getAttribute("cian-query")) {
                    this.setAttribute("cian-query", window.location.hash.substring(1));
                }
                const page = this.getAttribute("page") || 1;
                let queryString = this.getCianQueryString(page);
                this.addEventListener("click", (e) => {
                    if (
                        e.target.hasAttribute(
                            "navigation-bank-main" ||
                            e.target.closest("[navigation-bank-main]")
                        )
                    ) {
                        this.dispatchEvent(
                            new CustomEvent("GO_BANK_MAIN", {bubbles: true})
                        );
                    }
                    if (
                        e.target.hasAttribute(
                            "navigation-search" || e.target.closest("[navigation-search]")
                        )
                    ) {
                        const customEvent = new CustomEvent("FIND_LIST", {bubbles: true});
                        customEvent.queryString = this.getCianQueryStringForSearch();
                        customEvent.newTab = false;
                        this.dispatchEvent(customEvent);
                    }
                    if (
                        e.target.hasAttribute(
                            "navigation-main" || e.target.closest("[navigation-main]")
                        )
                    ) {
                        this.dispatchEvent(new CustomEvent("GO_MAIN", {bubbles: true}));
                    }
                    if (
                        e.target.hasAttribute(
                            "show-more" || e.target.closest("[show-more]")
                        )
                    ) {
                        this.setAttribute(
                            "page",
                            Number.parseInt(this.getAttribute("page") || "1") + 1
                        );
                    }
                    if (e.target.id === "add-advert-button") {
                        this.saveEvent("button-clicked", "go-add-advert-from-listing-jk");
                        window.open("https://www.cian.ru/razmestit-obyavlenie/", "_blank");
                    }
                });

                const [, partnerProgramsFlag] =
                /partner_programs=([^&]+)/.exec(queryString) || [];
                const ids = partnerProgramsFlag === "true" ? this.getBuilderIds() : [];
                serachJkNonConcurrent(queryString, ids)
                    .then(({data}) => {
                        const {jkCards, similarTitle, total} = data;
                        console.log({data});
                        const mainJkTitle = this.querySelector("main-jk-title");
                        const similarJkTitle = this.querySelector("similar-jk-title");
                        const contentContainer = this.querySelector(
                            "[cian-jk-listing-content]"
                        );
                        const showMoreBlock = this.querySelector("[button-bar]");
                        // const seoCrossLinksBlock = this.querySelector('[seo-cross-links-block]');
                        if (window.innerWidth > 1023) {
                            if (jkCards.length > 15)
                                jkCards.splice(15, 0, '<cd-ad-place place="15"></cd-ad-place>');
                            if (jkCards.length > 10)
                                jkCards.splice(10, 0, '<cd-ad-place place="10"></cd-ad-place>');
                            if (jkCards.length > 8)
                                jkCards.splice(
                                    8,
                                    0,
                                    '<banner-billboard-cn sn="2"></banner-billboard-cn>'
                                );
                            if (jkCards.length > 8)
                                jkCards.splice(
                                    8,
                                    0,
                                    '<rbk-banners-tgb-cn-mobile sn="5"></rbk-banners-tgb-cn-mobile>'
                                );
                            if (jkCards.length > 5)
                                jkCards.splice(5, 0, '<cd-ad-place place="5"></cd-ad-place>');
                            if (jkCards.length > 4)
                                jkCards.splice(
                                    4,
                                    0,
                                    '<banner-billboard-cn sn="1"></banner-billboard-cn>'
                                );
                            if (jkCards.length > 4)
                                jkCards.splice(
                                    4,
                                    0,
                                    '<rbk-banners-tgb-cn-mobile sn="6"></rbk-banners-tgb-cn-mobile>'
                                );
                        }
                        if (mainJkTitle && similarTitle) {
                            mainJkTitle.style.display = "none";
                            similarJkTitle.style.display = "flex";
                            similarJkTitle.innerText = similarTitle;
                            showMoreBlock.style.display = "none";
                        } else {
                            mainJkTitle.style.display = "flex";
                            similarJkTitle.style.display = "none";
                            showMoreBlock.style.display = "flex";
                        }
                        let rest = total - page * 25;
                        if (showMoreBlock) {
                            if (rest <= 0) {
                                showMoreBlock.style.display = "none";
                            } else {
                                showMoreBlock.style.display = "flex";
                            }
                        }
                        contentContainer.innerHTML = jkCards.join("\n");
                        this.dispatchEvent(
                            new CustomEvent("JK_SEARCH_RESULT_READY", {bubbles: true})
                        );
                    });
            }

            reloadCurrentPage(page) {
                const splash = document.createElement("div");
                splash.style.position = "fixed";
                splash.style.top = "0";
                splash.style.left = "0";
                splash.style.width = "100%";
                splash.style.height = "100%";
                splash.style.background = "#FFFFFF80";
                splash.style.zIndex = 1000;
                document.body.appendChild(splash);
                const queryString = this.getCianQueryString(page);
                const [, partnerProgramsFlag] =
                /partner_programs=([^&]+)/.exec(queryString) || [];
                const ids = partnerProgramsFlag === "true" ? this.getBuilderIds() : [];

                serachJkNonConcurrent(queryString, ids)
                    .then(({data}) => {
                        const {jkCards, similarTitle, total, breadCrumbs, bounds} = data;
                        console.log({ data1: data })
                        this.setAttribute('bounding-rect', JSON.stringify({bounds}))
                        window.cian_map_bounding_rect = {bounds};
                        const breadCrumbsToRender = breadCrumbs
                            .map((bc, i, arr) => {
                                const link = `<a href="${bc.url}" style="color: inherit;text-decoration: none;cursor: pointer">${bc.title}</a>`;
                                if (i + 1 === arr.length) {
                                    return link;
                                } else return link + " / ";
                            })
                            .join("");
                        const seoBreadCrumbs = this.querySelector("[serp-seo-breadcrumbs]");
                        if (seoBreadCrumbs) {
                            seoBreadCrumbs.innerHTML = `${breadCrumbsToRender}`;
                        }

                        const mainJkTitle = this.querySelector("main-jk-title");
                        const similarJkTitle = this.querySelector("similar-jk-title");
                        const contentContainer = this.querySelector(
                            "[cian-jk-listing-content]"
                        );
                        // const crossLinksContainer = this.querySelector('[seo-cross-links-block]');
                        const showMoreBlock = this.querySelector("[button-bar]");

                        if (jkCards.length > 0 && page > 1) {
                            if (mainJkTitle && similarTitle) {
                                mainJkTitle.style.display = "none";
                                similarJkTitle.style.display = "flex";
                                similarJkTitle.innerText = similarTitle;
                                showMoreBlock.style.display = "none";
                            } else {
                                mainJkTitle.style.display = "flex";
                                similarJkTitle.style.display = "none";
                                showMoreBlock.style.display = "flex";
                            }
                            contentContainer.insertAdjacentHTML(
                                "beforeend",
                                jkCards.join("\n")
                            );
                        }

                        if (jkCards.length > 0 && page === 1) {
                            if (mainJkTitle && similarTitle) {
                                mainJkTitle.style.display = "none";
                                similarJkTitle.style.display = "flex";
                                similarJkTitle.innerText = similarTitle;
                                showMoreBlock.style.display = "none";
                            } else {
                                mainJkTitle.style.display = "flex";
                                similarJkTitle.style.display = "none";
                                showMoreBlock.style.display = "flex";
                            }
                            contentContainer.innerHTML = jkCards.join("\n");
                        }

                        if (jkCards.length === 0 && page > 1) {
                            mainJkTitle.style.display = "flex";
                            similarJkTitle.style.display = "none";
                            showMoreBlock.style.display = "none";
                            contentContainer.insertAdjacentHTML(
                                "beforeend",
                                jkCards.join("\n")
                            );
                        }

                        if (jkCards.length === 0 && page === 1) {
                            if (mainJkTitle && similarTitle) {
                                mainJkTitle.style.display = "none";
                                similarJkTitle.style.display = "flex";
                                similarJkTitle.innerText = similarTitle;
                                showMoreBlock.style.display = "none";
                                contentContainer.innerHTML = jkCards.join("\n");
                            }
                        }

                        let rest = total - page * 25;
                        if (showMoreBlock) {
                            if (rest <= 0) {
                                showMoreBlock.style.display = "none";
                            } else {
                                showMoreBlock.style.display = "flex";
                            }
                        }
                        // document.body.removeChild(splash);
                        // crossLinksContainer.innerHTML = crossLinks;
                        this.dispatchEvent(
                            new CustomEvent("JK_SEARCH_RESULT_READY", {bubbles: true})
                        );
                    })
                    .catch((e) => {
                        console.log("failed fetch offers: ", e);
                    })
                    .finally(() => document.body.removeChild(splash));
            }

            saveEvent(eventType, serviceName) {
                try {
                    const href = window.location.href;
                    const regionMatcher = href.match("(?:region=)([0-9]+)");
                    const regionId =
                        regionMatcher && regionMatcher[1] ? regionMatcher[1] : "undefined";
                    let cianCdUser = localStorage.getItem("cianCdUser");
                    let cianCdSession = sessionStorage.getItem("cianCdSession");
                    let cianUserAbGroup = localStorage.getItem("cianUserAbGroup");
                    fetch(
                        "https://cd-business-events-collector.content.cian.ru/events/",
                        {
                            credentials: "include",
                            method: "POST",
                            body: JSON.stringify({
                                serviceName: serviceName,
                                eventType: eventType,
                                data: {
                                    regionId: regionId,
                                    cianCdUser: cianCdUser,
                                    cianCdSession: cianCdSession,
                                    cianUserAbGroup: cianUserAbGroup,
                                    pwa:
                                        !!window.sessionStorage &&
                                        sessionStorage.getItem("pwa") === "true",
                                },
                            }),
                            headers: {
                                "Content-Type": "application/json",
                                "Access-Control-Allow-Origin": "*",
                            },
                        }
                    )
                        .then((r) => r.json())
                        .then((responseData) => {
                            window.cianUserAbGroup = responseData.cianUserAbGroup;
                            localStorage.setItem("cianCdUser", responseData.cianCdUser);
                            sessionStorage.setItem(
                                "cianCdSession",
                                responseData.cianCdSession
                            );
                            localStorage.setItem(
                                "cianUserAbGroup",
                                responseData.cianUserAbGroup
                            );
                        });
                } catch (e) {
                    console.log("===============failed save visited===============");
                }
            }
        }
    );
if (!customElements.get("cian-content-serp-jk-card"))
    customElements.define(
        "cian-content-serp-jk-card",
        class extends HTMLElement {
            connectedCallback() {
                this.addEventListener("click", (e) => {
                    if (e.target.closest("[metro-popup-control]")) {
                        let element = this.querySelector("[metro-popup]");
                        if (element.style.display === "none") {
                            element.style.display = "block";
                        } else element.style.display = "none";
                        e.stopPropagation();
                    }
                });
            }
        }
    );
if (!customElements.get("cian-content-serp-jk-card-flat-type"))
    customElements.define(
        "cian-content-serp-jk-card-flat-type",
        class extends HTMLElement {
            static get observedAttributes() {
                return ["offers-url"];
            }

            attributeChangedCallback(attributeName, oldValue, newValue) {
                if (attributeName === "offers-url" && oldValue !== newValue) {
                    this._offersUrl = newValue;
                }
            }

            connectedCallback() {
                this.addEventListener("click", (e) => {
                    const queryString = this._offersUrl.match("[?](.*)")[1];
                    let findListEvent = new CustomEvent("FIND_LIST", {bubbles: true});
                    findListEvent.queryString = queryString;
                    if (window.innerWidth >= 768) findListEvent.newTab = true;
                    this.dispatchEvent(findListEvent);
                    e.stopPropagation();
                });
            }
        }
    );

if (!customElements.get("cian-content-serp-jk")) customElements.define("cian-content-serp-jk", class extends HTMLElement {
        async connectedCallback() {
            const platform = window.innerWidth < 768 ? "mobile" : "desktop";

            this.addEventListener("click", (e) => {
                const customEvent = new CustomEvent("SHOW_JK", {bubbles: true});
                customEvent.jkRef = this.getAttribute("jk-ref");
                if (platform === "desktop") customEvent.newTab = true;
                this.dispatchEvent(customEvent);
            });

            let cacheUrl = false;
            let renderUrl = false;
            if (this.hasAttribute("jk-ref")) {
                const jkRef = this.getAttribute("jk-ref");
                const path = /\/(.*)\/$/.exec(jkRef)[1];
                cacheUrl = `https://cdn.cian.site/finance/content-distribution/serp-jk/${path}-${platform}.html`;
                renderUrl = `https://content-distribution-jk-search.content.cian.ru/serp-jk?q=${encodeURIComponent(
                    jkRef
                )}&platform=${platform}`;
            }

            axios
                .get(cacheUrl, {timeout: 3000})
                .then(({data}) => data)
                .catch(() => {
                    return axios
                        .get(renderUrl, {timeout:5000})
                        .then(({data}) => data)
                        .catch(() => "");
                })
                .then((html) => {
                    this.innerHTML = html;
                    if (this.hasAttribute("rooms")) {
                        this.querySelectorAll(
                            "cian-content-serp-jk-card-flat-type"
                        ).forEach((v) => (v.style.display = "none"));
                        JSON.parse(this.getAttribute("rooms")).forEach((room) => {
                            let roomSelector = false;
                            switch (room) {
                                case "oneRoom":
                                    roomSelector = "room1=1";
                                    break;
                                case "twoRoom":
                                    roomSelector = "room2=1";
                                    break;
                                case "threeRoom":
                                    roomSelector = "room3=1";
                                    break;
                                case "fourRoom":
                                    roomSelector = "room4=1";
                                    break;
                                case "fiveRoom":
                                    roomSelector = "room5=1";
                                    break;
                                case "large":
                                    roomSelector = "room6=1";
                                    break;
                                case "studio":
                                    roomSelector = "room9=1";
                                    break;
                            }
                            if (roomSelector) {
                                const v = this.querySelector(
                                    `cian-content-serp-jk-card-flat-type[offers-url*="${roomSelector}"]`
                                );
                                if (v) {
                                    v.style.display = "flex";
                                }
                            }
                        });
                    }
                });
        }
    }
);
